import {
  getStudentProgressNavLabel,
  isOnlineSchoolCapability,
} from "../../utils/associateCapabilities";

const createMenuItem = (title, path, icon, extras = {}) => ({
  title,
  path,
  icon,
  ...extras,
});

const createGroup = (label, items) => ({ label, items });

const sidebarConfig = (userInfo) => {
  const contentItems = [];

  if (isOnlineSchoolCapability(userInfo)) {
    contentItems.push(
      createMenuItem("Gallery", "/lesson-books", "mdi:book-open-page-variant", {
        accent: "gallery",
      }),
      createMenuItem("Training Lesson", "/training-lesson", "mdi:earth", {
        accent: "training",
      }),
    );
  } else {
    contentItems.push(
      createMenuItem("Gallery", "/lesson-books", "mdi:book-open-page-variant", {
        accent: "gallery",
      }),
    );
  }

  contentItems.push(
    createMenuItem("Islamic Topics", "/islamic-topics", "mdi:book-multiple", {
      accent: "topics",
    }),
  );

  return [
    createGroup("Main", [
      createMenuItem("Dashboard", "/dashboard", "mdi:view-dashboard", {
        exact: true,
        accent: "dashboard",
      }),
      createMenuItem("Feeds", "/feeds", "mdi:rss", { accent: "feeds" }),
      createMenuItem(
        getStudentProgressNavLabel(userInfo),
        "/student-reports",
        "mdi:clipboard-list",
        { accent: "reports" },
      ),
      createMenuItem("Activity Logs", "/activity-logs", "mdi:history", {
        accent: "activity",
      }),
      createMenuItem("Certificates", "/certificates", "mdi:certificate-outline", {
        accent: "certificates",
      }),
    ]),
    createGroup("Members", [
      createMenuItem("Clients", "/clients", "mdi:account-tie", {
        accent: "guardians",
      }),
      createMenuItem("Affiliates", "/associates", "mdi:handshake-outline", {
        matches: ["/associates", "/subjects"],
        accent: "affiliates",
      }),
      createMenuItem("Students", "/students", "mdi:school", {
        accent: "students",
      }),
      createMenuItem("Teachers", "/teachers", "mdi:teach", {
        accent: "teachers",
      }),
    ]),
    createGroup("Content", contentItems),
    createGroup("Account", [
      createMenuItem("Personal Notes", "/personal-notes", "mdi:notebook", {
        accent: "notes",
      }),
      createMenuItem("To Do Lists", "/to-do-lists", "mdi:format-list-checks", {
        accent: "todos",
      }),
    ]),
  ];
};

export default sidebarConfig;
